/**
 * EAA-1670: shared TanStack Query client for the Redux+Saga -> Zustand+TanStack
 * Query migration (see docs/plans/fe-restructure/phase-7-state-migration.md).
 * One client per app instance; domain hooks under `@/data/*` read/write through it.
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});
